import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Page Not Found | Castillo Painting Inc.";
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="flex items-center justify-center pt-28 pb-20 px-4">
        <div className="text-center max-w-lg">
          <h1 className="font-heading text-8xl md:text-9xl font-medium text-primary-500 mb-4">
            404
          </h1>
          <h2 className="font-heading text-2xl md:text-3xl font-medium text-foreground-950 mb-4">
            Page Not Found
          </h2>
          <p className="text-foreground-600 mb-8">
            The page you are looking for does not exist. Let us get you back to
            exploring our painting services.
          </p>
          <button
            onClick={() => navigate("/")}
            className="bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-sm font-medium tracking-wider uppercase hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Back to Home
          </button>
        </div>
      </main>
      <Footer />
    </div>
  );
}